import React from "react";
import Modal from '../../component/Inc/Modal';
function PopClassHistory(props) {
  const { open, close } = props;
  return (
    <Modal open={open} close={close} type="com_input pop_class_history" popSize="s">
      <h2 className='pop_tit'>수업 히스토리</h2>
      <div className="content_container scroll">
        <ul className="com_board_box">
          <li className="board_item">
            <div className="info">
              <span className="tit">학생명</span>
              <p className="cont"><button className="name btn_link">홍길동103 </button> (고3ㆍ경기고등학교ㆍ본사) </p>
            </div>
            <div className="info">
              <span className="tit">전화번호</span>
              <p className="cont">010-2023-3030</p>
            </div>
            <div className="info">
              <span className="tit">부모폰</span>
              <p className="cont">부)010-2023-3030 <span className="dot"/>모)010-3030-3333</p>
            </div>
            <div className="info">
              <span className="tit">홍보키</span>
              <p className="cont"><span className="btn_link">김홍보320</span></p>
            </div>
            <div className="info">
              <span className="tit">담임</span>
              <p className="cont"><span className="btn_link">김담임320</span></p>
            </div>
            <div className="info">
              <span className="tit">주소</span>
              <p className="cont"><span className="btn_link">경기도 수원시 수원빌딩</span></p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">수업장소</span>
              <p className="cont">경기도 수원시 팔달구 팔달로1234 모여라 빌딩 203호</p>
            </div>
          </li>
          <li className="board_item">
            <div className="info">
              <span className="tit">수업 과목</span>
              <p className="cont com_blue_txt">과탐 (사회문화,경제,밥과정서)</p>
            </div>
            <div className="info">
              <span className="tit">교사</span>
              <p className="cont"><i className="com_cancel_txt">김교사123</i> → 최교사405</p>
            </div>
            <div className="info">
              <span className="tit">교사 시수</span>
              <p className="cont">45,000</p>
            </div>
            <div className="info">
              <span className="tit">시수 변경</span>
              <p className="cont">원거리 시수 + 3,000 <button className="btn_report">원거리 배정 보고서</button></p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">회차 / 타임</span>
              <p className="cont">16회 / 2T</p>
            </div>
            <div className="info">
              <span className="tit">완성수업</span>
              <p className="cont"></p>
            </div>
            <div className="info">
              <span className="tit">수업 시간 / 방법</span>
              <p className="cont">30분 / 대면</p>
            </div>
            <div className="info">
              <span className="tit">첫수업일</span>
              <p className="cont">2023. 05. 12 12:30</p>
            </div>
            <div className="info">
              <span className="tit">수업일</span>
              <p className="cont">수, 목  12 :3p</p>
            </div>
            <div className="info">
              <span className="tit">수업 시간 / 방법</span>
              <p className="cont">30분 / 대면</p>
            </div>
            <div className="info">
              <span className="tit">비교수업</span>
              <p className="cont">N</p>
            </div>
            <div className="info">
              <span className="tit">동시수업</span>
              <p className="cont">김학생103, 최학생123, 최학생105</p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">DC코드 / 할인금액</span>
              <p className="cont">형제할인 5%ㆍ45,000</p>
            </div>
            <div className="info">
              <span className="tit">1회수업료</span>
              <p className="cont">45,000</p>
            </div>
            <div className="info">
              <span className="tit">수업료</span>
              <p className="cont com_blue_txt">2,495,000</p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">메모</span>
              <p className="cont">부모님이 홍길동 교사를 원하세요.</p>
            </div>
          </li>
          <li className="board_item">
            <div className="info">
              <span className="tit">영업 정보</span>
              <p className="cont">홍보ㆍ김담임103</p>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <span className="tit">수업변경</span>
              <p className="cont">
                <span className="date">2022, 05, 10</span> : 타임추가ㆍ 홍길동103 <br />
                <span className="date">2021, 06, 12</span> : 첫 수업전 취소 <br />
                <span className="date">2020, 04, 24</span> : 인계 ㆍ최교사405
              </p>
            </div>
          </li>
          <li className="board_item">
            <div className="info total">
              <span className="tit">총입금액</span>
              <p className="cont">95,000</p>
              <span className="bar" />
              <span className="tit">총입금회차</span>
              <p className="cont">45,5</p>
              <span className="bar" />
              <span className="tit com_red_txt">미수금</span>
              <span className="cont com_red_txt">55,000</span>
            </div>
            <hr className="com_divider" />
            <div className="info">
              <div className="cont date">
                <p>2023,05,10ㆍ수학ㆍ5회ㆍ750,000ㆍ홍길동ㆍ카드ㆍ하나카드 (1132-3221-32131)</p>
                <p>2023,05,10ㆍ수학ㆍ5회ㆍ750,000ㆍ홍길동ㆍ가상계좌ㆍ1132-3221-31231</p>
                <p>2023,05,10ㆍ수학ㆍ5회ㆍ750,000ㆍ홍길동ㆍ현금</p>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div className="btn_container">
        <button className="com_btn orange s">배정 변경</button>
        <button className="com_btn orange s">결제 변경</button>
        <button className="com_btn orange s">수업 변경</button>
      </div>
    </Modal>
  );
}

export default PopClassHistory;